<template>
  <div class="pc-layout" @contextmenu.prevent>
    <layout-sidebar v-show="!presentationMode"/>
    <router-view/>
    <contextmenu/>
    <contextmenu-mask/>
    <add-wizard-dialog/>
    <search-drawer/>
  </div>
</template>

<script>
import LayoutSidebar from '@/components/layouts/LayoutSidebar.vue'
import { mapGetters, mapMutations } from 'vuex'
import Contextmenu from '@/components/contextmenu/Contextmenu.vue'
import ContextmenuMask from '@/components/contextmenu/Mask.vue'
import AddWizardDialog from '@/components/dialog/AddWizardDialog.vue'
import SearchDrawer from '@/components/search/SearchDrawer.vue'
import key from 'keymaster'

export default {
  components: {
    LayoutSidebar,
    Contextmenu,
    ContextmenuMask,
    AddWizardDialog,
    SearchDrawer
  },
  mounted () {
    window.document.body.addEventListener('mousedown', this.hideContextmenuHandler)
    key('ctrl+s', (event) => {
      event.preventDefault()
    })
    key('ctrl+q', (event) => {
      event.preventDefault()
      this.setSearchVisible(true)
    })
  },
  destroyed () {
    window.document.body.removeEventListener('mousedown', this.hideContextmenuHandler)
  },
  methods: {
    ...mapMutations('contextmenu', {
      setContextmenuVisible: 'SET_VISIBLE'
    }),
    ...mapMutations('search', {
      setSearchVisible: 'SET_VISIBLE'
    }),
    hideContextmenuHandler () {
      this.setContextmenuVisible(false)
      if (window.contextmenuPopper) {
        window.contextmenuPopper.destroy()
        window.contextmenuPopper = null
      }
    }
  },
  computed: {
    ...mapGetters({
      presentationMode: 'workbench/presentationMode'
    })
  }
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';

.pc-layout {
  height: 100%;
  display: flex;
  flex-direction: rows;
}

.pc-layout__container {
  width: 0;
  flex-grow: 1;
}
</style>
